export const queryKeys = {
  contacts: {
    all: ['contacts'] as const,
    list: (filters?: Record<string, unknown>) => ['contacts', 'list', filters] as const,
    summary: () => ['contacts', 'summary'] as const,
    detail: (id: string) => ['contacts', id] as const,
    deals: (id: string) => ['contacts', id, 'deals'] as const,
  },
  grades: {
    all: ['grades'] as const,
    byContact: (contactId: string) => ['grades', 'contact', contactId] as const,
  },
  keepInTouch: {
    all: ['keep-in-touch'] as const,
    list: (horizonDays?: number) => ['keep-in-touch', horizonDays] as const,
  },
  interactions: {
    all: ['interactions'] as const,
    byContact: (contactId: string) => ['interactions', 'contact', contactId] as const,
  },
  outreach: {
    all: ['outreach'] as const,
    byContact: (contactId: string) => ['outreach', 'contact', contactId] as const,
    history: (contactId: string) => ['outreach', 'contact', contactId, 'history'] as const,
    queue: () => ['outreach', 'queue'] as const,
  },
  templates: {
    all: ['templates'] as const,
    detail: (id: string) => ['templates', id] as const,
  },
  retro: {
    weekly: (weekOf?: string) => ['retro', 'weekly', weekOf] as const,
    history: (limit?: number) => ['retro', 'history', limit] as const,
    historyDetail: (id: string) => ['retro', 'history', id] as const,
  },
  enrichment: {
    status: (contactId: string) => ['enrichment', contactId] as const,
  },
  usage: {
    current: () => ['usage'] as const,
  },
  userSettings: {
    current: () => ['settings'] as const,
  },
  tags: {
    all: ['tags'] as const,
    vocabulary: () => ['tags', 'vocabulary'] as const,
  },
  parseJobs: {
    detail: (id: string) => ['parse-jobs', id] as const,
  },
  integrations: {
    google: () => ['integrations', 'google'] as const,
    hubspot: () => ['integrations', 'hubspot'] as const,
    hubspotSyncRuns: (limit?: number) => ['integrations', 'hubspot', 'sync-runs', limit] as const,
  },
  account: {
    deletionRequest: () => ['account', 'deletion-request'] as const,
  },
  notifications: {
    token: () => ['notifications', 'token'] as const,
    preferences: () => ['notifications', 'preferences'] as const,
  },
  context: {
    uploads: () => ['context', 'uploads'] as const,
    upload: (id: string) => ['context', 'uploads', id] as const,
    proposals: (status?: string) => ['context', 'proposals', status] as const,
    contactContexts: (contactId: string) => ['context', 'contact', contactId] as const,
  },
} as const;
